import { Client } from '@/common/services/Client';

export async function fetchBillingDocument(
  uuid: string,
  attachmentId: number,
  signal?: AbortSignal,
): Promise<Blob> {
  const response = await Client.get<Blob>({
    endpoint: `/billing/${uuid}/document/${attachmentId}`,
    headers: {
      Accept: 'application/pdf',
    },
    responseType: 'blob',
    signal,
  });
  return response.data;
}
